import React from 'react';
import Spinner from '../spinner';


export default () => {


    return <div id='moverlay' style={{
        height: "100%",
        width: "100%",
        display: 'none',
        position: "fixed",
        zIndex: 9999,
        left: 0,
        top: 0,
        backgroundColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.9)",
        overflowX: "hidden",
        transition: "3.5s",
    }}>

        <div style={{
            display: 'flex',
            flexDirection: 'column',
            height: "100%",
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            <Spinner grow size={5} color='success' />
        </div>

    </div>
};
